import renderChannelTypeIcon from 'components/ChannelPicker/renderChannelTypeIcon';
import { ChannelType } from 'components/ChannelPicker/types';
import { StyledChannelIcon, AvatarWrapper, StyledUserAvatar } from './styled';

interface AvatarWithChannelIconProps {
    initials?: string;
    src?: string;
    value?: string;
    channel?: ChannelType;
    customerChannel?: ChannelType;
    size?: 'small' | 'medium' | 'large';
    iconSize?: 'small' | 'medium' | 'large';
}

const getChannelIcon = (channel?: ChannelType) => {
    if (!channel || channel === 'all') return null;
    return renderChannelTypeIcon(channel);
};

const AvatarWithChannelIcon = ({
    initials,
    src,
    value,
    channel,
    customerChannel,
    size = 'medium',
    iconSize = 'small',
}: AvatarWithChannelIconProps) => {
    const icon = getChannelIcon(channel);
    return (
        <AvatarWrapper>
            <StyledUserAvatar
                initials={initials}
                src={src}
                value={value}
                channel={customerChannel}
                size={size}
            />
            <StyledChannelIcon size={iconSize} channel={channel}>
                {icon}
            </StyledChannelIcon>
        </AvatarWrapper>
    );
};

export default AvatarWithChannelIcon;
